/**
 * Created by Sergey Panpurin on 4/23/2017.
 */

// @ts-check
(function btInAppPurchaseMockServiceClosure() {
  'use strict';

  angular
    .module('btUtils')
    /**
     * @ngdoc service
     * @name btInAppPurchaseMockService
     * @memberOf btUtils
     * @description
     *  This service ???
     */
    .factory('btInAppPurchaseMockService', ['$q', '$timeout', btInAppPurchaseMockService]);

  /**
   *
   * @param {angular.IQService} $q - promise interface
   * @param {angular.ITimeoutService} $timeout - ?
   * @return {ext.IInAppPurchasePlugin}
   */
  function btInAppPurchaseMockService($q, $timeout) {
    var gProducts = [
      {
        productId: 'starter.monthly',
        title: 'Smart',
        description:
          'Features: statistically back-tested trade ideas for selected events, real time magnitude and insights for every release during a day, 14 days free trial!',
        price: '₱ 2,590.00',
        priceAsDecimal: 2590.0,
        currency: 'PHP',
      },
      {
        productId: 'smart.monthly',
        title: 'Smart',
        description:
          'Features: statistically back-tested trade ideas for selected events, real time magnitude and insights for every release during a day, 14 days free trial!',
        price: '4 490,00 ₽',
        priceAsDecimal: 4490.0,
        currency: 'RUB',
      },
      {
        productId: 'backtester.monthly',
        title: 'BackTester',
        description:
          'Features: statistically back-tested trade ideas for selected events, real time magnitude and insights for every release during a day, 14 days free trial!',
        price: '5 490,00 ₽',
        priceAsDecimal: 5490.0,
        currency: 'RUB',
      },
      {
        productId: 'starter.yearly',
        title: 'Smart',
        description:
          'Features: statistically back-tested trade ideas for selected events, real time magnitude and insights for every release during a day, 14 days free trial!',
        price: '₱ 22,490.00',
        priceAsDecimal: 22490.0,
        currency: 'PHP',
      },
      {
        productId: 'smart.yearly',
        title: 'Smart',
        description:
          'Features: statistically back-tested trade ideas for selected events, real time magnitude and insights for every release during a day, 14 days free trial!',
        price: '44 900,00 ₽',
        priceAsDecimal: 44900.0,
        currency: 'RUB',
      },
      {
        productId: 'backtester.yearly',
        title: 'BackTester',
        description:
          'Features: statistically back-tested trade ideas for selected events, real time magnitude and insights for every release during a day, 14 days free trial!',
        price: '54 900,00 ₽',
        priceAsDecimal: 54900.0,
        currency: 'RUB',
      },
    ];

    var gRestore = [
      {
        productId: 'basic.monthly',
        date: '2017-04-19T17:03:48Z',
        transactionId: '1000000292080679',
        state: 3,
      },
      {
        productId: 'basic.monthly',
        date: '2017-04-19T16:58:48Z',
        transactionId: '1000000292080680',
        state: 3,
      },
      {
        productId: 'basic.monthly',
        date: '2017-04-19T16:38:01Z',
        transactionId: '1000000292080681',
        state: 3,
      },
      {
        productId: 'basic.monthly',
        date: '2017-04-19T16:46:47Z',
        transactionId: '1000000292080682',
        state: 3,
      },
      {
        productId: 'basic.monthly',
        date: '2017-04-19T10:50:50Z',
        transactionId: '1000000292080683',
        state: 3,
      },
      {
        productId: 'basic.monthly',
        date: '2017-04-19T16:51:47Z',
        transactionId: '1000000292080684',
        state: 3,
      },
      {
        productId: 'basic.monthly',
        date: '2017-04-19T16:29:05Z',
        transactionId: '1000000292080685',
        state: 3,
      },
    ];

    var gBuyOrder = {
      transactionId: '1000000292082158',
      receipt:
        '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',
    };

    return {
      getProducts: function (productIds) {
        console.log(productIds);
        var deferred = $q.defer();
        $timeout(
          function () {
            deferred.resolve(gProducts);
          },
          1000,
          false
        );
        return deferred.promise;
      },
      subscribe: function (productId) {
        console.log(productId);
        var deferred = $q.defer();
        $timeout(
          function () {
            deferred.resolve(gBuyOrder);
          },
          1000,
          false
        );
        return deferred.promise;
      },
      buy: function (productId) {
        console.log(productId);
        var deferred = $q.defer();
        $timeout(
          function () {
            deferred.resolve(gBuyOrder);
          },
          1000,
          false
        );
        return deferred.promise;
      },
      consume: function (productType, receipt, signature) {
        console.log(productType, receipt, signature);
        var deferred = $q.defer();
        $timeout(
          function () {
            deferred.resolve();
          },
          1000,
          false
        );
        return deferred.promise;
      },
      restorePurchases: function () {
        var deferred = $q.defer();
        $timeout(
          function () {
            deferred.resolve(gRestore);
          },
          1000,
          false
        );
        return deferred.promise;
      },
      getReceipt: function () {
        var deferred = $q.defer();
        $timeout(
          function () {
            deferred.resolve(gBuyOrder.receipt);
          },
          1000,
          false
        );
        return deferred.promise;
      },
    };
  }
})();
